import React from 'react';
import { Box, Typography } from '@mui/material';

interface CenteredEmptyStateProps {
	message?: React.ReactNode;
}

const CenteredEmptyState: React.FC<CenteredEmptyStateProps> = ({ message = 'Add your first entry!' }) => {
	return (
		<Box
			sx={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				textAlign: 'center',
				pointerEvents: 'none',
			}}
		>
			<Typography variant="body2" color="text.secondary">
				{message}
			</Typography>
		</Box>
	);
};

export default CenteredEmptyState;

